export default __webpack_public_path__ + "static/media/wifi-best-practices.340f090e.png";